import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateOnboardingLink($id: Int!, $returnUrl: String!, $refreshUrl: String!, $isMerchant: Boolean, $type: String) {
    createOnboardingLink(payment_account_id: $id, input: { return_url: $returnUrl, refresh_url: $refreshUrl, is_merchant: $isMerchant, type: $type }) {
      object
      created
      expires_at
      url
    }
  }
`;
